import ApplyPaymentForm from './ApplyPaymentForm';

export default ApplyPaymentForm;
